import type { ComponentType, ReactNode } from "react";

interface NavListItemProps {
  icon?: ComponentType;
  children?: ReactNode;
}

export function NavListItem({ icon: Icon, children }: NavListItemProps) {
  return (
    <div className="flex flex-row flex-nowrap items-center gap-1 p-2 font-sans text-3xl">
      {Icon ? <Icon/> : null}
      <span className="text-base">{children}</span>
    </div>
  );
}

interface NavListSectionProps {
  children?: ReactNode;
}

export function NavListSection({ children }: NavListSectionProps) {
  return <div className="p-2 border border-[#ddd] bg-white">{children}</div>;
}

interface NavListSectionHeaderProps {
  children?: ReactNode;
}

export function NavListSectionHeader({ children }: NavListSectionHeaderProps) {
  return <div className="bg-[#ddd] p-2 text-base font-bold">{children}</div>;
}
